import Event from '../../core/Event';

export default class DataExportSucceeded extends Event {
    public static type = 'DataExportSucceeded';

    constructor() {
        super(DataExportSucceeded.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/DataExportSucceeded.ts